import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import AddTickets from '../../ticket-picker/components/AddTickets';
import ProductProps from './ProductComponent';
import FormattedCurrency from '@s/FormattedCurrency';
import ImageGalleryWrapper from '@s/ImageGalleryWrapper'
import DetailsToggle from '@s/DetailsToggle'
import ProductConfigurationWrapper from '../containers/ProductConfigurationWrapper'

export default class KioskProduct extends Component<ProductProps> {
    constructor(props) {
        super(props);
        this.state = {showDescription: false}
    }

    displayGallery = () => {
        let imageGallery = <div></div>;
        if (this.props.product.images && this.props.product.images.length > 1) {
            imageGallery = <Fragment>
                {this.state.showDescription === true &&
                 <div className="image__gallery">
                    <ImageGalleryWrapper
                        images={this.props.product.images}
                        altTexts={this.props.product.images_alt_texts}
                        name={this.props.product.name}
                    />
                </div>
                }
            </Fragment>;
        }

        return imageGallery;
    };

    toggleDescription = () => {
        this.setState({showDescription: !this.state.showDescription});
    };

    // getProductImageUrl = () => {
    //     return "url(" + this.props.product.images[0] + ")";
    // };

    displayProductConfiguration = () => {
        if (!this.props.product.single_configuration && this.props.productQuantity > 0) {
            let productConfigLines = [];
            for (let i = 0; i < this.props.productQuantity; i++) {
                productConfigLines.push(<div className="product__configuration__option" key={'config_line_' + i}>
                    <ProductConfigurationWrapper
                        key={i}
                        product={this.props.product}
                        configKey={i}
                        productQuantity={this.props.productQuantity}
                    />
                </div>);
            }

            return (<div className="product__configurations__wrapper">
                    {productConfigLines}
                </div>
            )
        }
    };

    render() {
        return <Fragment>
            <div className="ticket">
                <div className="ticket__information product__information">
                    <div className="product__image__name">
                        <div className="product__image">
                            {this.props.product.images?.length ? (
                              <img
                                src={this.props.product.images[0]}
                                alt={(this.props.product.images_alt_texts && this.props.product.images_alt_texts[0] && this.props.product.images_alt_texts[0].trim()) ? this.props.product.images_alt_texts[0] : `${this.props.product.name} Thumbnail`}
                              />
                            ) : (
                              <i className='icon icon-shopping_basket' />
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="ticket__name">{this.props.product.name}</div>
                        <div className="ticket__pricing-group">
                            <div className="ticket__price"><FormattedCurrency>{ this.props.product.price.amount }</FormattedCurrency></div>
                        </div>
                        {(this.props.product.description || (this.props.product.images && this.props.product.images.length > 1)) && (
                          <DetailsToggle
                            onClick={this.toggleDescription}
                            aria-expanded={this.state.showDescription}
                            aria-controls={`description_product_${this.props.product.product_id}`}
                          />
                        )}
                    </div>
                </div>
                <div className="ticket__action">
                    <AddTickets
                        onIncrement={this.props.onProductIncrement}
                        onDecrement={this.props.onProductDecrement}
                        quantity={this.props.productQuantity}
                        quantities={this.props.productQuantities}
                        onQuantityInput={this.props.onProductsQuantityInput}
                        initialQuantities={this.props.initialQuantities}
                    />
                </div>
            </div>
            {this.state.showDescription === true &&
                <div
                  id={`description_product_${this.props.product.product_id}`}
                  className="ticket-description__more"
                >
                    {this.displayGallery()}
                    <div className="ticket__description">
                        <div className="ticket-description__content ticket-description__content-desc">
                            {this.props.product.description}
                        </div>
                    </div>
                </div>
            }

            {this.displayProductConfiguration()}
        </Fragment>
    }
}

KioskProduct.propTypes = {
    product: PropTypes.object.isRequired,
    slug: PropTypes.string,
    productQuantity: PropTypes.number,
    productQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    onProductsQuantityInput: PropTypes.func.isRequired,
    onProductIncrement: PropTypes.func.isRequired,
    onProductDecrement: PropTypes.func.isRequired,
    createProductConfigurationLine : PropTypes.bool,
};
